module.exports = __webpack_public_path__ + "img/about_layout2.fd4299b0.png";